module.exports = __webpack_public_path__ + "static/img/redpack-withdraw2.cb2c073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/redpack-withdraw2.png
// module id = F5el
// module chunks = 213